// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c5851de","455":"94a0352c"}[chunkId] + ".chunk.js";
};